import api from './api';
import { Notification } from '../types';

export interface NotificationFilters {
  is_read?: boolean;
  type?: string;
  limit?: number;
}

export const notificationService = {
  getAll: async (filters?: NotificationFilters): Promise<Notification[]> => {
    const response = await api.get('/api/notifications', { params: filters });
    return response.data;
  },

  getUnreadCount: async (): Promise<number> => {
    const response = await api.get('/api/notifications/unread-count');
    return response.data.count;
  },

  markAsRead: async (id: number): Promise<void> => {
    await api.put(`/api/notifications/${id}/read`);
  },

  markAllAsRead: async (): Promise<void> => {
    await api.put('/api/notifications/read-all');
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/notifications/${id}`);
  },
};




